import { ChapterTextEnum } from "./chapter-text.enum";
import { ChapterEnum } from "./chapter.enum";

export const environment = {
  production: true,
  cognitoIdentityService:
    "CognitoIdentityServiceProvider.3lvo88o31j5i1jq0rve21rc6bh",
  webServiceEndpoint:
    "https://l1dy3caef2.execute-api.us-east-1.amazonaws.com/prod/assessments/",
  webServiceAssessment:
    "https://l1dy3caef2.execute-api.us-east-1.amazonaws.com/prod/assessments-pa/",
  GrowthEndpoint:
    "https://l1dy3caef2.execute-api.us-east-1.amazonaws.com/prod/growth-matrix/",
  endpointMultimedia: "https://d3jvm6ee97l28q.cloudfront.net",
  webServiceAchievements:
    "https://crecipdn.pragma.com.co:9020/achievements/api/v2/",
  webServiceChapterAdministration:
    "https://l1dy3caef2.execute-api.us-east-1.amazonaws.com/prod/administration/apis/graphql",
  webServiceChapter:
    "https://l1dy3caef2.execute-api.us-east-1.amazonaws.com/prod/administration/",
  webServiceScheduling:
    "https://l1dy3caef2.execute-api.us-east-1.amazonaws.com/prod/schedule/api/v1/",
  webGrowthRoute:
    "https://l1dy3caef2.execute-api.us-east-1.amazonaws.com/prod/growth-route/api/v1/",
  webServiceMapRating:
    "https://l1dy3caef2.execute-api.us-east-1.amazonaws.com/prod/map-rating/",
  webServiceMapConfiguration:
    "https://l1dy3caef2.execute-api.us-east-1.amazonaws.com/prod/map-configuration/",
  webComments:
    "https://l1dy3caef2.execute-api.us-east-1.amazonaws.com/prod/comments/api/comments",
  webAttachments:
    "https://l1dy3caef2.execute-api.us-east-1.amazonaws.com/prod/comments/api/attachments",
  webServiceSkillset:
    "https://l1dy3caef2.execute-api.us-east-1.amazonaws.com/prod/skillset/",
  chapters: {
    [ChapterEnum.FRONTEND]: ChapterTextEnum.FRONTEND,
    [ChapterEnum.BACKEND]: ChapterTextEnum.BACKEND,
  },
  assessmentKey: "x-api-key-prod",
  assessmentValue: "TCXEVYbAkt94VgmqHIgJUaXQo9A6JwuI3hFyh6Yt",

  applicationId: "b5054867-b005-4041-bf3b-baf68acd3eb7",
  clientToken: "pubdc5f224506335e3a4e366641c0ca14a8",
  site: "datadoghq.com",
  service: "-pragma-rum-creci-pdn",
  env: "pdn",
  defaultPrivacyLevel: "allow",
  productionFrontendUrl: "https://mapadecrecimiento.pragma.com.co/login",
  surveyFeedbackUrl: "https://shirt-mess-64667085.figma.site/",
  jarvisChatEnabled: true,
  jarvisWsUrl: 'wss://n03an058fj.execute-api.us-east-1.amazonaws.com/v1',
  jarvisCognitoClientId: '3lvo88o31j5i1jq0rve21rc6bh',
  jarvisSource: 'creci-pdn',
  jarvisEvaluatorWsUrl: 'wss://3lh5c30er2.execute-api.us-east-1.amazonaws.com/v1',
};
